.empty-placeholder-wrapper {
  width: 100%;
  height: 100%;

  div {
    user-select: none;
    background-color: transparent;
    background-size: 24rem;
    max-width: unset;

    p {
      display: inline-block;
      font-weight: 500;
      font-size: 2.4rem;
      color: var(--color-grayscale-cadet, #afb4c0);
    }
  }
}
